import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { CustomerSegment, CustomerSegmentCreate, CustomerSegmentFilter } from '../data/customerSegment';

export function createCustomerSegmentService(client: AxiosInstance) {
  return createCrudService<CustomerSegment, CustomerSegmentCreate, CustomerSegmentFilter>(
    client,
    '/crm/CustomerSegment',
    'id',
  );
}

export type CustomerSegmentService = CrudService<CustomerSegment, CustomerSegmentCreate, CustomerSegmentFilter>;
